// The needs-attention queue, shared by the Dashboard and the nav badge (same
// query keys, so one set of requests).
//
//   server items     GET /platform/dashboard → attention, minus its 30-day
//                    `inactive`
//   inactive (14d)   tenants with no league-admin activity for 14+ days,
//                    from the tenant list's last_activity_at (super-admins
//                    excluded)

import { api, inactiveAttention, sortAttention, type AttentionItem, type DashboardResponse } from '@/api'
import { useQuery } from './query'

export interface AttentionQueue {
  items: AttentionItem[]
  dashboard: DashboardResponse | undefined
  status: 'loading' | 'success' | 'error'
  error: unknown
  refetch: () => void
}

export function useAttentionQueue(): AttentionQueue {
  const dash = useQuery(['dashboard'], (signal) => api.dashboard.get(signal))
  const list = useQuery(['tenants', 'all'], (signal) => api.tenants.list({ page_size: 100, sort: '-last_activity_at' }, signal))

  let items: AttentionItem[] = []
  if (dash.data) {
    const serverItems = dash.data.attention.filter((i) => i.kind !== 'inactive')
    const inactive = inactiveAttention(
      (list.data?.leagues ?? []).map((t) => ({ tenant: { id: t.id, name: t.name, subdomain: t.subdomain }, status: t.account.status, last_activity_at: t.last_activity_at, created_at: t.created_at })),
    )
    items = sortAttention([...serverItems, ...inactive])
  }

  const status = dash.status === 'error' ? 'error' : dash.data ? 'success' : 'loading'
  return {
    items,
    dashboard: dash.data,
    status,
    error: dash.error,
    refetch: () => {
      dash.refetch()
      list.refetch()
    },
  }
}
